import script from "./UiTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiTab.vue?vue&type=script&setup=true&lang=ts"

import "./UiTab.vue?vue&type=style&index=0&id=4ea59180&lang=css"

const __exports__ = script;

export default __exports__